import React from "react"
import { Box, Link, Image } from "rebass"
import MCDLogo from "../images/mcd-logo.svg"

const Header = () => (
  <Box
    py={3}
    sx={{
      color: "text",
    }}
    css={{
      textAlign: "center",
      borderBottom: "2px solid",
    }}
  >
    <Link href="https://www.mcdbooks.com">
      <Image src={MCDLogo} width={72} height={72} />
    </Link>
  </Box>
)

export default Header
